//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { jssdk, isIphonex } from '@runwork/runwork-help'

export default {
  props: {
    question: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
  },
  data() {
    return {
      editorOption: {
        modules: { toolbar: [] },
        placeholder: '请输入',
      },
    }
  },
  methods: {
    onEditorChange(event) {
      event.quill.deleteText(500, 4)
    },
    addQuestion(item) {
      this.$emit('onadd', this.question)
    },
  },
}
